/**
 * How workspace surfaces attach context to chat.
 *
 * - `submit` — visible user turn (Compli / Marq "share to chat" buttons).
 * - `pin` — silent pin for the next model turns (Norma codebook viewer auto-inject).
 *
 * Default: `codebook-viewer` pins; every other injection type submits so
 * existing share-to-chat call sites stay unchanged.
 */

export type ContextInjectionMode = 'submit' | 'pin'

export type ContextInjectionType =
  | 'sentiment'
  | 'trends'
  | 'trace'
  | 'evaluate'
  | 'doc-assessment'
  | 'home'
  | 'compose'
  | 'doc-clause-map'
  | 'doc-pyramid'
  | 'process-map'
  | 'gaps'
  | 'codebook-viewer'

export interface PinnedChatContext {
  text: string
  type: ContextInjectionType
  label: string
}

export function resolveContextInjectionMode(
  type: ContextInjectionType,
  explicit?: ContextInjectionMode,
): ContextInjectionMode {
  if (explicit) return explicit
  return type === 'codebook-viewer' ? 'pin' : 'submit'
}

/** Synthetic history framing for a silently pinned codebook viewer context. */
export function formatPinnedChatContextPair(text: string): {
  user: string
  assistant: string
} {
  return {
    user:
      '[Active codebook viewer context — pinned for this session; not a user message. ' +
      'Use the version / form identifiers below when calling codebook_* tools.]\n\n' +
      text,
    assistant: 'Understood — I have the active codebook viewer context.',
  }
}
